import React from 'react'
import NavConfig from '../../../config/CloudNavConfig'
import {Dropdown, Layout, Menu} from "antd";
import {Link, withRouter} from "react-router-dom";
import LogoCollapsed from '../../../images/layout/logo_collapsed.svg'
import {Path} from "../../public/path";
import {CheckOutlined, DownOutlined} from "@ant-design/icons";
import Utils from "../../public/utils";

const {Sider} = Layout;
const {SubMenu} = Menu;

class QwSider extends React.Component {

    constructor(props) {
        super(props);
        this.getSiderConfig = this.getSiderConfig.bind(this);
        this.getDefaultKeys = this.getDefaultKeys.bind(this);
        this.state = {
            siderConfig: NavConfig,
            collapsed: false,
            sysSwitchVisible: false,
            pathMap: {},
            accountMessage:{}
        }
    }

    componentWillMount() {
        this.getDefaultKeys();
    }

    componentDidMount() {
        this.getSiderConfig();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.getSiderConfig();
        if(nextProps.accountMessage!='{}' && nextProps.accountMessage !=undefined){
            if(nextProps.accountMessage.isSub == 1){
                this.setState({
                    siderConfig:Utils.newNavConfig(nextProps.accountMessage.permissionConf.wxworkHelperPro,'wxworkHelperPro')
                },()=>{
                    this.getSiderConfig();
                })
            }
            this.setState({
                accountMessage:nextProps.accountMessage
            })
        }
    }

    getSubmenuKey(menuKey, index) {
        return menuKey + '#' + index
    }

    getDefaultKeys() {
        let defaultOpenKeys = [];
        let selectedKeys = [];
        this.state.siderConfig.map((item) => {
            if (item.isOpen) {
                defaultOpenKeys.push(item.key)
            } else {
                let submenu = item.submenu;
                if (submenu && submenu.length > 0) {
                    submenu.map((subitem, index) => {
                        if (subitem.pathIn && subitem.pathIn()) {
                            defaultOpenKeys.push(item.key);
                            selectedKeys.push(this.getSubmenuKey(item.key, index))
                        }
                    })
                }
            }
        })
        this.setState({
            defaultOpenKeys: defaultOpenKeys,
            selectedKeys: selectedKeys
        })
    }

    getSiderConfig() {
        let selectedKeys = [];
        let pathMap = {};
        this.state.siderConfig.map((item) => {
            let submenu = item.submenu;
            if (submenu && submenu.length > 0) {
                submenu.map((subitem, index) => {
                    if (subitem.path) {
                        pathMap[this.getSubmenuKey(item.key, index)] = subitem;
                    }
                    if (subitem.pathIn && subitem.pathIn()) {
                        selectedKeys.push(this.getSubmenuKey(item.key, index))
                    }
                })
            } else if (item.path) {
                pathMap[item.key] = item;
            }
        });
        this.setState({
            selectedKeys: selectedKeys,
            pathMap: pathMap
        });
    }

    navClick(e) {
        let key = e.key;
        let pathMap = this.state.pathMap;
        let path = pathMap[key];
        if(path.path == '/im/chat'){
            path.link=true
        }
        if (path) {
            if (path.link) {
                window.open(path.path);
            } else {
                this.props.history.push(path.path);
            }
        }
    }

    collapseChange(val) {
        this.setState({
            collapsed: val,
        })
    }

    render() {
        let menu = (
            <Menu className={'sysSwitchMenu'}>
                <Menu.Item key="1" title={''}><Link
                    to={Path.getDashboard()}><CheckOutlined/>紫鲲</Link></Menu.Item>
                <Menu.Item key="2" title={''} className='active'><Link
                    to={Path.getZkCloudHome()}><CheckOutlined/>企微助手Pro</Link></Menu.Item>
            </Menu>
        );
        return (
            <Sider className='qy-sider' width={250} collapsed={this.state.collapsed}>
                <div className='qy-sider-menu'>
                    {
                        this.state.accountMessage.isSub == 0 ?
                            <Menu mode="inline"
                                  inlineIndent={16}
                                  defaultOpenKeys={this.state.defaultOpenKeys}
                                  selectedKeys={this.state.selectedKeys}
                                  onClick={this.navClick.bind(this)}
                            >
                                {
                                    this.state.siderConfig && this.state.siderConfig.map((sider) => {
                                        return (
                                            sider.submenu && sider.submenu.length > 0 ?
                                                <SubMenu popupClassName={'qy-sider-submenu qy-sider-submenu-dark'}
                                                         key={sider.key}
                                                         title={
                                                             <span>
                                            {sider.icon}
                                                                 <span>{sider.title}</span>
                                    </span>
                                                         }>
                                                    {
                                                        this.state.collapsed ? <li className='qy-sider-collapsed-submenu-title'
                                                                                   key={sider.key}>{sider.title}</li> : ''
                                                    }
                                                    {
                                                        sider.submenu.map((submenu, index) => {
                                                            return <Menu.Item
                                                                key={this.getSubmenuKey(sider.key, index)}><span
                                                                className='qy-sider-submenu-content'>{submenu.title}</span></Menu.Item>
                                                        })
                                                    }
                                                </SubMenu> : <Menu.Item popupClassName={'qy-sider-submenu'}
                                                                        className={`qy-sider-home ${sider.pathIn && sider.pathIn() ? 'active' : ''}`}
                                                                        key={sider.key}><span>{sider.icon}<span>{sider.title}</span></span></Menu.Item>
                                        )
                                    })
                                }
                            </Menu> :
                            <Menu mode="inline"
                                  inlineIndent={16}
                                  defaultOpenKeys={this.state.defaultOpenKeys}
                                  selectedKeys={this.state.selectedKeys}
                                  onClick={this.navClick.bind(this)}
                            >
                                {
                                    this.state.siderConfig && this.state.siderConfig.map((sider) => {
                                        if(sider.checked == 1){
                                            return (
                                                sider.submenu && sider.submenu.length > 0 ?
                                                    <SubMenu popupClassName={'qy-sider-submenu qy-sider-submenu-dark'}
                                                             key={sider.key}
                                                             title={
                                                                 <span>{sider.icon}<span>{sider.title}</span></span>
                                                             }>
                                                        {
                                                            this.state.collapsed ? <li className='qy-sider-collapsed-submenu-title'
                                                                                       key={sider.key}>{sider.title}</li> : ''
                                                        }
                                                        {
                                                            sider.submenu.map((submenu, index) => {
                                                                if(submenu.checked == 1){
                                                                    return <Menu.Item
                                                                        key={this.getSubmenuKey(sider.key, index)}><span
                                                                        className='qy-sider-submenu-content'>{submenu.title}</span></Menu.Item>
                                                                }
                                                            })
                                                        }
                                                    </SubMenu> : <Menu.Item popupClassName={'qy-sider-submenu'}
                                                                            className={`qy-sider-home ${sider.pathIn && sider.pathIn() ? 'active' : ''}`}
                                                                            key={sider.key}><span>{sider.icon}<span>{sider.title}</span></span></Menu.Item>
                                            )
                                        }
                                    })
                                }
                            </Menu>
                    }

                </div>
            </Sider>
        );
    }
}

export default QwSider